<div class="row ">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">


                <!-- cabecera -->
                <div class="row mb-2">
                    <div class="col-3">
                        <div class="form-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   [(ngModel)]="textoDestacado"
                                   (keyup)="buscarTodo($event)" />
                        </div>
                    </div>

                    <!-- Pasillos -->
                    <div class="col-md-2">
                        <div class="form-group row ">
                            <label for="example-text-input"
                                   class="col-md-4 col-form-label text-right">Pasillos: </label>
                            <div class="col-md-8">
                                <select class="form-control border border-dark rounded"
                                        name="pasillo"
                                        [(ngModel)]="pasillo"
                                        (change)="filtroUbiChange()">
                                    <option value="*">Todos</option>
                                    <option *ngFor="let val of pasillosList"
                                            [value]="val">
                                        {{val}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <!-- Alturas -->
                    <div class="col-md-2">
                        <div class="form-group row ">
                            <label for="example-text-input"
                                   class="col-md-4 col-form-label text-right">Alturas: </label>
                            <div class="col-md-8">
                                <select class="form-control border border-dark rounded"
                                        name="altura"
                                        [(ngModel)]="altura"
                                        (change)="filtroUbiChange()">
                                    <option value="*">Todas</option>
                                    <option *ngFor="let alt of alturasList"
                                            [value]="alt">
                                        {{alt}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <!-- Seleccionar todo -->
                    <div class="col-md-2">
                        <div class="demo-checkbox">
                            <input id="chkMenu"
                                   type="checkbox"
                                   class="filled-in"
                                   [(ngModel)]="selectAllRows"
                                   (ngModelChange)="toggleSelectAllRows()" />
                            <label for="chkMenu">Seleccionar todo </label>
                        </div>
                    </div>

                    <!-- Seleccionar NO asignados -->
                    <div class="col-md-1">
                        <div class="demo-checkbox">
                            <input id="selectNoAssigned"
                                   type="checkbox"
                                   class="filled-in"
                                   [(ngModel)]="selectNoAssigned"
                                   (ngModelChange)="toggleNoAssigned()" />
                            <label for="selectNoAssigned">NO asignados </label>
                        </div>
                    </div>


                    <div class="col-md-2">
                        <form>

                            <div class="row float-right">

                                <div class="col-md-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="9999">Todo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">
                                            <button type="button"
                                                    (click)="refreshData()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Refrescar Datos">
                                                <i class="fa-solid fa-refresh"></i>
                                            </button>
                                            <button *ngIf="refreshInterval"
                                                    type="button"
                                                    (click)="stopRefreshInterval()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Pausar actualización automática">
                                                <i class="fa-solid fa-pause"></i>
                                            </button>
                                            <button *ngIf="!refreshInterval"
                                                    type="button"
                                                    (click)="resetRefreshInterval()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Reanudar actualización automática">
                                                <i class="fa-solid fa-play"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>
                                        </div>

                                        <!-- Progress bar -->
                                        <div *ngIf="!selected.length"
                                             class="progress mt-1"
                                             style="height: 3px;">
                                            <div class="progress-bar bg-info"
                                                 role="progressbar"
                                                 [style.width.%]="progressPercentage"
                                                 [attr.aria-valuenow]="progressPercentage"
                                                 aria-valuemin="0"
                                                 aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                </div>



                <div class="rounded border">
                    <small>
                        Selecciona ubicaciones/artículos para la asignación de la campaña <b>{{campanyaInfo.camp_cod}}</b>
                        <span *ngIf="campanyaInfo.campanyaTipo==='1 a 1'"
                              class="text-warning ml-1">
                            <i> Campaña tipo pedido 1 a 1</i>
                            <img src="../../../assets/images/icon/1a1.png"
                                 height="20px"
                                 alt="1 a 1"
                                 class="d-inline-block ml-2">
                        </span>
                    </small>

                    <!-- Progress bar -->
                    <!-- <div *ngIf="!selected.length"
                         class="progress mb-1"
                         style="height: 3px;">
                        <div class="progress-bar bg-info"
                             role="progressbar"
                             [style.width.%]="progressPercentage"
                             [attr.aria-valuenow]="progressPercentage"
                             aria-valuemin="0"
                             aria-valuemax="100"></div>
                    </div> -->

                    <!-- datatable -->
                    <ngx-datatable class="bootstrap pointer"
                                   [style.width]="'100%'"
                                   [rows]="rows"
                                   [columnMode]="ColumnMode.flex"
                                   [headerHeight]="50"
                                   [footerHeight]="50"
                                   [messages]="messages"
                                   rowHeight="auto"
                                   [limit]=rowsLimit
                                   [selected]="selected"
                                   [selectionType]="SelectionType.multiClick"
                                   (activate)="onActivate($event)"
                                   [summaryRow]="true"
                                   [summaryHeight]="50"
                                   [summaryPosition]="summaryPosition">



                        <!-- id -->
                        <ngx-datatable-column name="Id"
                                              prop='id'
                                              [flexGrow]="60"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span [ngClass]="{ 'text-warning': row.estado === 1 }">
                                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- recogida_cod -->
                        <ngx-datatable-column name="Cód.recogida"
                                              prop='recogida_cod'
                                              [flexGrow]="140"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span [ngClass]="{ 'text-warning': row.estado === 1 }">
                                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- estado -->
                        <ngx-datatable-column name="Estado"
                                              prop='estado'
                                              [flexGrow]="120"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div *ngIf="row.recogida_cod"
                                     [innerHTML]="value | carritoEstado"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- id_articulo -->
                        <ngx-datatable-column name="id_articulo"
                                              prop='id_articulo'
                                              [flexGrow]="60"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span [ngClass]="{ 'text-warning': row.estado === 1 }">
                                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- foto -->
                        <ngx-datatable-column name=""
                                              prop='foto'
                                              [flexGrow]="40"
                                              [resizeable]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-row="row"
                                         let-value="value">
                                <div *ngIf="value">
                                    <img [src]="fotoDir +'/articulos' + imgResized + value"
                                         loading="lazy"
                                         alt="Foto"
                                         class="rounded pointer border"
                                         height="25px"
                                         title="foto">
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- sku -->
                        <ngx-datatable-column name="Sku"
                                              prop='sku'
                                              [flexGrow]="130"
                                              [summaryFunc]="cuentaCeldas">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span [ngClass]="{ 'text-warning': row.estado === 1 }">
                                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- ean -->
                        <ngx-datatable-column name="ean"
                                              [flexGrow]="150">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="pointer link"><i class="fa fa-barcode"></i> Ean</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- ubicacion -->
                        <ngx-datatable-column name="Ubicación"
                                              prop='ubicacion'
                                              [flexGrow]="145">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div class="monospace"
                                     title="{{funcLib.CodUbiDecript(value)}}"
                                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- username -->
                        <ngx-datatable-column name="Asignado a"
                                              prop='username'
                                              [flexGrow]="90">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- cant_reserva -->
                        <ngx-datatable-column name="Cantidad"
                                              prop='cant_reserva'
                                              [flexGrow]="75"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- cant_recogida -->
                        <ngx-datatable-column name="Recogido"
                                              prop='cant_recogida'
                                              [flexGrow]="75"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div [ngClass]="{
                                                'bg-blue':       row.estado === Constantes.ESTADO_PREPARACION_EMPEZADO,
                                                'bg-green':      row.estado === Constantes.ESTADO_PREPARACION_COMPLETADA,
                                                'bg-warning':    row.estado === Constantes.ESTADO_PREPARACION_ERROR
                                                }"
                                     class="pr-2"
                                     [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>





                        <!-- cant_inicial -->
                        <ngx-datatable-column name="Inicial"
                                              prop='cant_inicial'
                                              [flexGrow]="70"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div class="pr-2"
                                     [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>





                        <!-- stock -->
                        <ngx-datatable-column name="Stock"
                                              prop='stockUbi'
                                              [flexGrow]="70"
                                              [cellClass]="'text-right'"
                                              [summaryFunc]="sumaCeldas">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- saltar -->
                        <ngx-datatable-column name="Incidencia"
                                              prop='saltar'
                                              [maxWidth]="300"
                                              [flexGrow]="130">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div *ngIf="value"
                                     [innerHTML]="funcLib.resaltarTexto('⚠️ ' + value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- Acciones -->
                        <ngx-datatable-column [flexGrow]="40"
                                              [sortable]="false"
                                              [resizeable]="false">

                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-left">


                                        <a (click)="resetPreparacion(row)"
                                           class="link mr-2 pointer dropdown-item"
                                           [ngClass]="{ 'disabled': row.cant_recogida == 0  }"
                                           title="Modificar la cantidad recogida para este artículo y ubicación">
                                            <i class="fa-solid fa-pen-to-square"></i> Modificar cantidad recogida ({{row.cant_recogida}}/{{row.cant_repartida}})
                                        </a>

                                        <a (click)="muestraCajasRecogidas(row)"
                                           class="link mr-2 dropdown-item"
                                           [ngClass]="{ 'disabled': row.cant_recogida == 0 || campanyaInfo.campanyaTipo !== '1 a 1' }"
                                           placement="top"
                                           title="Mostrar la distribución de esta recogida en cajas">
                                            <i class="fa-solid fa-box"></i> Ver Cajas recogidas
                                        </a>

                                        <a *ngIf="(row.estado !== Constantes.ESTADO_PREPARACION_COMPLETADA) && (row.cant_recogida > 0) && (row.cant_reserva === row.cant_recogida)"
                                           (click)="marcarComoAcabada(row)"
                                           class="link mr-2 pointer dropdown-item"
                                           title="Marcar como acabada esta línea de recogida">
                                            <i class="fa-solid fa-check"></i> Marcar como acabada
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a [routerLink]="['/panel/articulo_edit',row.id_articulo]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Editar artículo">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar artículo
                                        </a>
                                        <a (click)="eanLabelsSrv.imprimirEanLabel(row.id_articulo)"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Generar etiquetas EAN">
                                            <i class="fa-solid fa-barcode"></i> Generar etiquetas EAN
                                        </a>

                                    </div>
                                </div>


                                <span *ngIf="!row.ubicacion">
                                    <a (click)="buscaStock(row)"
                                       class="link mr-2 pointer"
                                       title="Buscar Stock">
                                        <span class="acciones-badge">S</span>
                                    </a>
                                </span>
                            </ng-template>

                        </ngx-datatable-column>



                    </ngx-datatable>


                </div>


                <div class="card border border-dark rounded mt-4 p-1">
                    <div class="row">

                        <div class="col-md-6">
                            <div class="card bg-light">
                                <div class="card-body">
                                    <p class="card-text">
                                        <span class="h3">{{clienteInfo.nombre}}</span> <br>
                                        Campaña: {{campanyaInfo.camp_cod}} <span class="text-success">{{campanyaInfo.descripcion}} </span><br>
                                        Fecha de entrada: {{campanyaInfo.fecha_entrada}}
                                    </p>
                                    <hr>
                                    <p class="card-text">
                                        Total pedidos: {{campanyaInfo.tot_pedidos | number: '0.0-0':'es'}} <br>
                                        Total artículos: {{campanyaInfo.tot_articulos | number: '0.0-0':'es'}} <br>
                                        Total referencias: {{campanyaInfo.tot_referencias | number: '0.0-0':'es'}} <br>
                                    </p>
                                </div>
                            </div>
                        </div>





                        <div *ngIf="selected.length"
                             class="col-md-6">


                            <!-- form de detall -->
                            <form class="form"
                                  [formGroup]="campForm"
                                  (ngSubmit)="enviar()"
                                  class="form-horizontal">


                                <div>
                                    <div class="form-body">

                                        <div class="card bg-light">
                                            <div class="card-body">

                                                <!-- id_usuario -->
                                                <div class="col-12">
                                                    <div class="form-group"
                                                         [ngClass]="{ 'has-danger': enviado && f['id_usuario'].errors }">
                                                        <label class="form-control-label">Asignar recogida de artículos al usuario:</label>
                                                        <select formControlName="id_usuario"
                                                                class="form-control"
                                                                [ngClass]="{ 'form-control-danger': enviado && f['id_usuario'].errors }">
                                                            <option value=''>Selecciona...</option>
                                                            <option *ngFor="let usuario of userList"
                                                                    [value]="usuario.id">
                                                                <b>{{usuario.username}}</b> - {{usuario.nombre}}
                                                            </option>
                                                        </select>
                                                        <div *ngIf="enviado && f['id_usuario'].errors"
                                                             class="form-control-feedback">
                                                            <div *ngIf="f['id_usuario'].errors['required']">Obligatorio</div>
                                                            <div *ngIf="campForm.get('id_usuario')?.errors?.['apiError']">{{
                                                                campForm.get('id_usuario')?.errors?.['apiError'] }}</div>
                                                        </div>
                                                    </div>

                                                    <hr>
                                                    <p class="card-text">
                                                        Total ubicaciones seleccionadas: {{selected.length | number: '0.0-0':'es'}} <br>
                                                        Total articulos seleccionados: {{totSelCantidad | number: '0.0-0':'es'}} <br>
                                                    </p>



                                                </div>

                                            </div> <!-- card-body -->

                                        </div>
                                    </div>


                                    <hr>

                                    <div class="d-flex">
                                        <button [disabled]="loading"
                                                type="button"
                                                class="btn waves-effect waves-light btn-rounded btn-secondary"
                                                (click)="cancelarSelecctedClick()">Cancelar</button>

                                        <button [disabled]="loading"
                                                type="submit"
                                                class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                                            <i *ngIf="loading"
                                               class="fa fa-spinner fa-spin"></i>
                                            Enviar
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>


                        <div *ngIf="!selected.length"
                             class="col-md-6">
                            <button *ngIf="campanyaInfo.camp_cod"
                                    [disabled]="loading"
                                    type="button"
                                    class="btn btn-outline-info btn-rounded mt-2"
                                    [routerLink]="['/panel/asignar_pedidos/', id_campanya]"> <i class="fa-solid fa-box-open"></i> Ver Preparaciones de {{campanyaInfo.camp_cod}}
                                <img *ngIf=" campanyaInfo.campanyaTipo === '1 a 1'"
                                     src="../../../assets/images/icon/1a1.png"
                                     height="25px"
                                     alt="1 a 1"
                                     class="d-inline-block ml-1 mb-1">
                            </button>
                            <br>

                            <button [disabled]="loading"
                                    type="button"
                                    class="btn btn-outline-secondary btn-rounded mt-2"
                                    [routerLink]="'/panel/campanyas_lista'">Volver</button>
                        </div>


                    </div> <!-- row -->
                </div> <!-- card -->







                <!-- Cajas recogidas -->
                <span *ngIf="cajasRecogidas.length > 0">
                    <div class="card">

                        <div class="card-body border rounded">

                            <h5 class="text-info"> <i class="fa-solid fa-box"></i> Cantidades recogidas por cajas <b>{{cajasRecogidas[0].recogida_cod}}</b></h5>
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Recogida</th>
                                        <th>UIC</th>
                                        <th><i class="fa fa-barcode"></i> Ean</th>
                                        <th class="text-right">Por caja</th>
                                        <th class="text-right">Cajas</th>
                                        <th class="text-right">Total</th>
                                        <th class="text-center"
                                            width="30px"> </th>
                                    </tr>
                                </thead>
                                <tbody class="fs-10">
                                    <ng-container *ngFor="let rec of cajasRecogidas; let i = index">
                                        <!-- Si el uic es diferente al anterior, mostrar una línea horizontal -->
                                        <tr *ngIf="i > 0 && rec.uic !== cajasRecogidas[i-1].uic">
                                            <td colspan="7"
                                                class="p-0">
                                                <hr class="m-0 border-dark">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ rec.recogida_cod }}</td>
                                            <td>{{ rec.uic }}</td>
                                            <td>{{ rec.ean }}</td>
                                            <td class="text-right">{{ rec.cant_cajas_unidades | number: '0.0-0':'es' }}</td>
                                            <td class="text-right">{{ rec.cajas | number: '0.0-0':'es' }}</td>
                                            <td class="text-right"> <b>{{ rec.cajas * rec.cant_cajas_unidades | number: '0.0-0':'es' }}</b></td>
                                            <td class="text-center">
                                                <a *ngIf="rec.estado !== Constantes.ESTADO_PREPARACION_COMPLETADA"
                                                   class="text-danger pointer"
                                                   (click)="delCajaRecogida(rec)"
                                                   title="Eliminar esta recogida de cajas">
                                                    <i class="fa-regular fa-trash-can fa"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                                <tfoot class="bg-light font-weight-bold">
                                    <tr>
                                        <td colspan="7"
                                            class="p-0">
                                            <hr class="m-0 border-dark">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">TOTAL</td>
                                        <td class="text-right">{{ totCajas | number: '0.0-0':'es' }}</td>
                                        <td class="text-right">{{ totCantidadCajas | number: '0.0-0':'es' }}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>

                        </div> <!-- card-body -->
                    </div> <!-- card -->
                </span>







            </div> <!-- card-body -->

        </div>
    </div>


</div>





<!-- modal para edición de la preparación -->
<app-modal-recogida-modif></app-modal-recogida-modif>